import subscriptionModule from "../subscriptionModule";
import {CurrentUser } from "Roblox";

function subscriptionService(premiumService, eventStreamService, subscriptionConstant) {
    "ngInject";
    const { eventTypes, context } = subscriptionConstant;

    return {
        
        sendEventForMembershipManagementMessaging: function (purchasePlatform) {
            eventStreamService.sendEventWithTarget(eventTypes.showMembershipManagementMessaging, context.purchasePlatformIsDifferent, { uid: CurrentUser.userId, currentDevice: premiumService.getUsersCurrentPlatform(), purchaseDevice: purchasePlatform});
        }
    };
}

subscriptionModule
    .factory("subscriptionService", subscriptionService);

export default subscriptionService;